import { useIntl } from '@/intl'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import {
  SkiAreaMinimumAltitudeMetersFilter,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/SkiAreaFilters/SkiAreaMinimumAltitudeMetersFilter'
import {
  SkiAreaSlopeKmsFilter,
} from '@/scopes/search/search/pages/SearchPage/components/Filters/SkiAreaFilters/SkiAreaSlopeKmsFilter'
import { Accordion } from '@sunwebgroup/ui-components/uds'
import { isEmpty } from 'ramda'
import * as React from 'react'

export function SkiAreaFilters() {
  const intl = useIntl()
  const { options: skiAreaMinAltitudeOptions } = useSelectFilter('SkiAreaMinimumAltitudeMeters')
  const { options: skiAreaSlopeKmsOptions } = useSelectFilter('SkiAreaSlopeKms')

  if (isEmpty(skiAreaMinAltitudeOptions) && isEmpty(skiAreaSlopeKmsOptions)) {
    return null
  }
  return (
    <Accordion.Item
      title={intl.formatMessage({ id: 'search_filter_ski_area_label' })}
      defaultOpen
    >
      <SkiAreaMinimumAltitudeMetersFilter />
      <SkiAreaSlopeKmsFilter />
    </Accordion.Item>
  )
}
